<template>
  <b-modal
    :id="`modal-action-${action}`"
    :ref="`modal-action-${action}`"
    :title="`${title} documento`"
    data-cy="modal-action-document"
    :ok-title="title"
    cancel-title="Cancelar"
    @ok="commitAction"
    :ok-disabled="loading"
    @cancel="cancelProcess"
    @close="cancelProcess"
    size="lg"
  >
    <b-overlay :show="loading">
      <div class="mt-2">
        <form data-vv-scope="comment-management" v-if="action !== 'attach'">
          <vs-textarea
            class="mb-2"
            maxlength="1000"
            counter="1000"
            label="Comentario"
            v-model="comment"
            data-cy="comment"
            name="comment"
            v-validate="{required: (action === 'reject' || action === 'comment'), min: action === 'reject' ? 5 : 1}"
          />
          <div v-if="errors.first('comment-management.comment')"
               class="con-text-validation span-text-validation-danger
           vs-input--text-validation-span v-enter-to">
          <span class="span-text-validation">
            {{errors.first('comment-management.comment')}}
          </span>
          </div>
        </form>
        <div class="my-5 text-right" v-if="enableAttachButton">
          <UploadMultipleFiles
            permission="*"
            text="Agregar"
            v-model="file"
            :upload-to="urlFile"
            :maxSizeInMb="100"
            type-button="small"
            button-class=""
            container-class="text-right"
            @input="addAdditionalFile($event)"
          />
        </div>
        <div class="row">
          <div class="col-9" v-if="!commentFiles.length && action === 'attach'">
            <b>No hay documentos adjuntados. Seleccione al menos uno.</b>
          </div>
          <div class="col-2" v-for="file in commentFiles" :key="file.id">
            <div class="d-flex flex-column align-items-center">
              <vs-icon icon="description" size="30px" color="primary" />
              <b class="text-truncate w-100 text-center">
                {{ file.name }}
              </b>
              <vs-button
                color="danger"
                type="flat"
                icon="clear"
                @click="removeAdditionalFile(file.id)"
              />
            </div>
          </div>
        </div>
      </div>
    </b-overlay>
  </b-modal>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';
import {
  VBToggle,
  BModal,
  VBModal
} from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';

import Base64Mixin from '@/febos/global/_vue/mixins/Base64Mixin';
import UploadMultipleFiles from '@/febos/global/_vue/componentes/UploadMultipleFiles';

export default {
  components: {
    UploadMultipleFiles,
    BModal
  },
  mixins: [Base64Mixin],
  data() {
    return {
      loading: false,
      error: {
        message: ''
      },
      comment: '',
      file: [],
      commentFiles: []
    };
  },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    urlFile() {
      const { flowId } = this.$route.params;
      return `febos-io/global/${process.env.VUE_APP_AMBIENTE}/empresas/aprobaciones/${flowId}/comentarios`;
    },
    enableAttachButton() {
      return !this.isSiss;
    },
    isSiss() {
      return this.company.iut === '61221000-4';
    }
  },
  methods: {
    ...mapActions('Approvals', [
      'commentFileFlow',
      'processFileFlow'
    ]),
    cancelProcess() {
      this.comment = '';
      this.file = [];
      this.commentFiles = [];
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    makeObjectRequest() {
      const request = {
        idEjecucion: this.$route.params.flowId,
        idAprobacion: this.$route.params.fileId,
        pasoId: this.stepId.id
      };

      const actions = {
        approve: 'aprobar',
        reject: 'rechazar',
        return: 'devolver',
        comment: 'comentario',
        resend: 'reenviar',
        attach: 'adjuntar'
      };

      const body = {
        comentario: {
          accion: actions[this.action],
          comentario: this.comment
        },
        documentos: this.commentFiles.map((file) => ({
          tipo: actions[this.action],
          nombre: file.name,
          adjuntoId: file.id,
          adjuntoUrl: file.path,
          adjuntoMime: file.mime,
          adjuntoEstado: 2
        }))
      };
      if (this.newFlow) {
        const newFlowAttachments = this.newFlow.adjuntos.filter((fileAt) => fileAt.seleccionado);
        const bodyNewFlow = {
          pasos: this.newFlow.pasos,
          documentos: this.newFlow.documentos,
          adjuntos: newFlowAttachments,
          aprobacionesReferenciaId: this.newFlow.aprobacionesReferenciaId
        };
        if (this.newFlow.processConsequence) {
          const meta = {};
          meta.idGatillador = this.newFlow.processConsequence && this.newFlow.processConsequence.aprobacionesGatilladorProcesoId;
          meta.gatillacionFlujo = bodyNewFlow && this.encode(JSON.stringify(bodyNewFlow));
          meta.gatillacion = {
            ...this.newFlow.processConsequence,
            configuracion: this.newFlow.processConsequence && this.encode(JSON.stringify(this.newFlow.processConsequence)),
          };
          body.meta = meta;
        }
      }

      if (this.action !== 'comment' || this.action !== 'attach') {
        body.estado = actions[this.action].toUpperCase();
        body.temporalUsuario = '';
        body.temporalUsuarioId = '';
        body.temporalContinuar = false;
      }

      return { request, body };
    },
    async sendAction() {
      const isValid = await this.validateForm('comment-management');
      if (!isValid) {
        return;
      }
      if (this.action === 'attach' && !this.commentFiles.length) {
        return;
      }
      this.loading = true;
      console.log('SE ENVIA COMENTARIO');
      if (this.action === 'comment' || this.action === 'attach') {
        const response = await this.commentFileFlow(this.makeObjectRequest());
        this.$bvToast.toast(
          `${response.mensaje}`,
          {
            title: '¡Genial!',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
      } else {
        const response = await this.processFileFlow(this.makeObjectRequest());
        this.$bvToast.toast(
          `${response.mensaje}`,
          {
            title: '¡Genial!',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
      }
      this.loading = false;
      this.comment = '';
      this.file = [];
      this.commentFiles = [];
      this.$refs[`modal-action-${this.action}`].hide();
    },
    commitAction(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.sendAction();
    },
    async addAdditionalFile(event) {
      const files = Array.isArray(event) ? event : [];
      if (!files.length) {
        return;
      }

      const uniqueFiles = [...this.commentFiles];
      files.forEach((file) => {
        if (!uniqueFiles.find((stored) => stored.id === file.id)) {
          uniqueFiles.push(file);
        }
      });
      this.commentFiles = uniqueFiles;
      this.file = [...uniqueFiles];
      await this.$validator.reset();
    },
    removeAdditionalFile(fileId) {
      this.commentFiles = this.commentFiles.filter((file) => file.id !== fileId);
      this.file = this.file.filter((file) => file.id !== fileId);
    },
  },
  mounted() {
    this.comment = '';
    this.commentFiles = [];
  },
  props: {
    action: { type: String, required: true },
    title: { type: String, required: true },
    process: { type: Boolean, required: false },
    stepId: { type: Object, required: false },
    getSign: Function,
    numPages: Number,
    newFlow: Object
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple,
    'b-modal': VBModal
  },
};
</script>
